var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMembership3 = function SvgMembership3(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: ref
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "96.295%",
    y1: "0%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9500"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "M22.59 8.471H9.884V5.443a.5.5 0 0 0-.853-.354L4.236 9.883l4.794 4.794a.5.5 0 0 0 .853-.353v-3.029h12.708a1.412 1.412 0 1 0 0-2.824Z",
    transform: "rotate(90 15.62 14.384)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0771AE",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M26.453 12.564h4.256a3.53 3.53 0 0 1 3.53 3.53v15.885a3.53 3.53 0 0 1-3.53 3.53H9.53A3.53 3.53 0 0 1 6 31.979V16.094a3.53 3.53 0 0 1 3.53-3.53h4.268"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.97 21.254)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F50909",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 2,
    d: "m14.53 9.262-.762-.054-.148-.75a3.375 3.375 0 0 0-6.303-.896l-.248.473-.53.057a2.499 2.499 0 0 0 .272 4.985h7.583a1.92 1.92 0 0 0 1.917-1.916 1.91 1.91 0 0 0-1.78-1.899Z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMembership3);
export default ForwardRef;